import { useI18n } from './I18nContext';

/**
 * Returns a function that picks the right-language value from a content object.
 * Usage: const localized = useLocalizedContent();
 *        localized(post, 'title')  -> post.title_no || post.title (when lang=='no')
 */
export const useLocalizedContent = () => {
  const { lang } = useI18n();
  return (obj, key) => {
    if (!obj) return '';
    if (lang === 'no') {
      const noVal = obj[`${key}_no`];
      if (noVal && typeof noVal === 'string' && noVal.trim()) return noVal;
    }
    return obj[key] || '';
  };
};
